// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__DRN1i","button":"styles_button__1c96I","buttonFake":"styles_buttonFake__1g3va"};